var H = Object.defineProperty, J = Object.defineProperties;
var K = Object.getOwnPropertyDescriptors;
var k = Object.getOwnPropertySymbols;
var O = Object.prototype.hasOwnProperty, T = Object.prototype.propertyIsEnumerable;
var S = (s, r, t) => r in s ? H(s, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[r] = t, d = (s, r) => {
  for (var t in r || (r = {}))
    O.call(r, t) && S(s, t, r[t]);
  if (k)
    for (var t of k(r))
      T.call(r, t) && S(s, t, r[t]);
  return s;
}, C = (s, r) => J(s, K(r));
import { jsx as o, Fragment as U, jsxs as A } from "react/jsx-runtime";
import { Children as X, useState as m, useRef as D, useEffect as Y } from "react";
import Z from "./components/Bullets.js";
import E from "./components/Arrows.js";
import { DefaultProps as M } from "./utils/defaultProps.js";
/* empty css                                               */const rt = ({
  children: s,
  id: r,
  bullet: t,
  arrow: i,
  qtyItems: u,
  gapItems: W = 4,
  itemWidthProp: f = 0,
  isMobile: g
}) => {
  const y = X.toArray(s), [F, N] = m(0), [B, I] = m(0), [Q, R] = m(f), [V, j] = m(null), c = D(null), l = D(null), v = {
    bullets: d(d({}, M.styles.bullets), t == null ? void 0 : t.style),
    arrows: d(d({}, M.styles.arrows), i == null ? void 0 : i.style)
  }, p = () => {
    if (c.current) {
      const n = c.current.scrollWidth, e = c.current.scrollLeft, a = c.current.offsetWidth, h = Math.ceil(n / a), G = Math.round(e / (n / h) - 0.3) + 1;
      j(`${G}/${h}`);
    }
  }, w = () => {
    if (c.current && l.current) {
      const n = l.current.clientWidth, e = c.current.scrollLeft, a = Math.round(e / n);
      I(a);
    }
  }, L = (n) => {
    if (c.current && l.current) {
      const e = l.current.clientWidth;
      n === "prev" && (c.current.scrollLeft -= e), n === "next" && (c.current.scrollLeft += e);
    }
  }, $ = () => {
    if (c.current && l.current) {
      const n = l.current.clientWidth, e = c.current.offsetWidth, a = c.current.scrollWidth, h = Math.round((a - e) / n);
      N(u ? Math.ceil(y.length - u) : h);
    }
  }, _ = (n) => {
    if (c.current && l.current) {
      const e = l.current.clientWidth;
      c.current.scrollLeft = e * n;
    }
  }, x = (n) => {
    if (c.current && f === 0) {
      const a = c.current.offsetWidth / n;
      R(a);
    }
  }, z = {
    width: `${f || (Q < 150 ? 150 : 226)}px`
  };
  return typeof window != "undefined" && window.addEventListener("resize", () => {
    p(), $(), u && x(u);
  }), Y(() => {
    var n;
    u && x(u), $(), p(), (n = c.current) == null || n.addEventListener("scroll", () => {
      p(), w();
    });
  }, [c]), /* @__PURE__ */ o(U, { children: /* @__PURE__ */ A("div", { id: "carousel", "data-testid": "Carousel", children: [
    /* @__PURE__ */ A("div", { className: "carousel-content", children: [
      (i == null ? void 0 : i.isVisible) && /* @__PURE__ */ o("div", { className: "carousel-arrow-button-prev", children: /* @__PURE__ */ o(
        E,
        {
          position: "prev",
          style: v.arrows,
          iconColor: i.iconColor || "#ccc",
          onClick: () => L("prev")
        }
      ) }),
      /* @__PURE__ */ o(
        "div",
        {
          ref: c,
          className: "carousel-container",
          id: `carousel-container-tracking${r ? "-" + r : ""}`,
          children: y.map((n, e) => /* @__PURE__ */ o(
            "div",
            {
              className: "container-item",
              style: C(d({}, z), {
                transition: "all 0.5s  ease-out",
                marginRight: `${g ? 0 : W}px`,
                marginBottom: `${g ? W : 0}px`
              }),
              ref: l,
              children: n
            },
            e
          ))
        }
      ),
      i != null && i.isVisible ? /* @__PURE__ */ o("div", { className: "carousel-arrow-button-next", children: /* @__PURE__ */ o(
        E,
        {
          position: "next",
          style: v.arrows,
          iconColor: i.iconColor || "#ccc",
          onClick: () => L("next")
        }
      ) }) : ""
    ] }),
    (t == null ? void 0 : t.numeric) && /* @__PURE__ */ o("div", { className: "numeric-bullets", children: V }),
    t != null && t.isVisible ? /* @__PURE__ */ o("div", { className: "bullets-container", children: Array.from({ length: F + 1 }, (n, e) => e + 1).map(
      (n, e) => /* @__PURE__ */ o(
        Z,
        {
          onClick: () => {
            _(e);
          },
          index: e,
          style: C(d({}, v.bullets), {
            transition: "all 0.8s  ease-out",
            backgroundColor: `${B === e ? (t == null ? void 0 : t.bulletEnableColor) || "#ff0000" : (t == null ? void 0 : t.bulletDisableColor) || "#ccc"}`
          }),
          isActive: B === e
        },
        e
      )
    ) }) : ""
  ] }) });
};
export {
  rt as Carousel
};
